module.exports = __webpack_public_path__ + "static/media/LogoIcon.d313cbc3.svg";